import { useState, useEffect } from "react";
import moment from "moment-timezone";
import {
  Grid,
  Typography,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Button,
} from "@mui/material";
import ReleaseDetails from "./ReleaseDetails";
import request from "../../../utilities/requests";

const ReleaseNotes = () => {
  const [notes, setNotes] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async (page) => {
    const result = await request(`releasenotes?page=${page || 1}`);
    if (result.success) {
      if (page > 1) {
        setNotes((prevNotes) => [...prevNotes, ...result.notes]);
      } else {
        setNotes(result.notes);
      }
      setPage(result.page);
      setHasMore(result.hasMore);
    }
  };

  const formatDate = (d) => {
    const userTimezone = moment.tz.guess();
    return moment.tz(d, userTimezone).format("YYYY-MM-DD");
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ padding: 20 }}
      direction="column"
      spacing={3}
    >
      <Grid item>
        <Typography variant="h4" align="center">
          Release Notes
        </Typography>
      </Grid>
      <Grid item>
        <Typography align="center">
          Review the latest functionality as it is released
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3}>
          <List>
            {notes.map((d) => (
              <div key={d._id}>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedNote(d);
                      setDialogOpen(true);
                    }}
                  >
                    <ListItemText
                      primary={d.title}
                      secondary={formatDate(d.createdAt)}
                    />
                  </ListItemButton>
                </ListItem>
                <Divider />
              </div>
            ))}
          </List>
        </Paper>
      </Grid>
      {hasMore ? (
        <Grid item>
          <Button onClick={() => getData(page + 1)}>Show more</Button>
        </Grid>
      ) : null}
      <ReleaseDetails
        open={dialogOpen}
        close={() => {
          setDialogOpen(false);
          setSelectedNote(null);
        }}
        note={selectedNote}
      />
    </Grid>
  );
};

export default ReleaseNotes;
